import { PurchaseIntentionErrorCodes } from '@types'

export enum ReservationError {
  Completed = 'payment reservation has already been processed',
  InvalidOtp = 'submitted otp is incorrect',
  ExpiredOtp = 'otp expired or not found',
}

export enum PaymentOption {
  CASH_PAYMENT = 'cash-payment',
  RESERVATION = 'reservation',
}

export enum Plan {
  WEEKLY = '7',
  BIWEEKLY = '14',
  THREE_WEEKS = '21',
  MONTHLY = '28',
}

export enum Frequency {
  ONE_TIME = '1',
  TWO_TIMES = '2',
  THREE_TIMES = '3',
  FOUR_TIMES = '4',
}

export enum PurchaseIntentionStatus {
  Expired = 'expired',
  Completed = 'completed',
  Pending = 'pending',
  VerificationPending = 'verification_pending',
}

export enum SupplierName {
  FRUBANA = 'frubana',
  FREXCO = 'frexco',
  ARADO = 'arado',
  LEONORA = 'leonora',
}

export enum CheckoutFeedbackStatus {
  MERCHANT_NOT_APPROVED = 'merchant-not-approved',
  MERCHANT_NOT_FOUND = 'merchant-not-found',
  BLOCKED_MERCHANT = 'blocked-merchant',
  WAITING_LIMIT = 'waiting-limit',
  MINIMUM_AMOUNT = 'minimum-amount',
  BLOCKED_KYC = 'blocked-kyc',
  BLOCKED_BGC = 'blocked-bgc',
  VERIFICATION_PENDING = 'verification_pending',
  EXPIRED = 'expired',
  COMPLETED = 'completed',
  INSUFFICIENT_LIMIT = 'insufficient-limit',
}

export const FEEDBACK_STATUS_FROM_ERROR_CODE = {
  [PurchaseIntentionErrorCodes.MERCHANT_BLOCKED_KYC]:
    CheckoutFeedbackStatus.BLOCKED_KYC,
  [PurchaseIntentionErrorCodes.MERCHANT_BLOCKED]:
    CheckoutFeedbackStatus.BLOCKED_MERCHANT,
  [PurchaseIntentionErrorCodes.MINIMUM_AMOUNT]:
    CheckoutFeedbackStatus.MINIMUM_AMOUNT,
  [PurchaseIntentionErrorCodes.NOT_ENOUGH_LIMIT]:
    CheckoutFeedbackStatus.INSUFFICIENT_LIMIT,
  [PurchaseIntentionErrorCodes.MERCHANT_WAITING_LIMIT]:
    CheckoutFeedbackStatus.WAITING_LIMIT,
  [PurchaseIntentionErrorCodes.MERCHANT_NOT_APPROVED]:
    CheckoutFeedbackStatus.MERCHANT_NOT_APPROVED,
  [PurchaseIntentionErrorCodes.MERCHANT_NOT_FOUND]:
    CheckoutFeedbackStatus.MERCHANT_NOT_FOUND,
  [PurchaseIntentionErrorCodes.MERCHANT_BLOCKED_BGC]:
    CheckoutFeedbackStatus.BLOCKED_BGC,
}
